import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { AgeGate } from "@/components/AgeGate";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";
import ResearchGuidelines from "@/pages/ResearchGuidelines";
import TrackOrder from "@/pages/TrackOrder";
import Support from "@/pages/Support";
import HowToPayWithCrypto from "@/pages/HowToPayWithCrypto";
import RestrictedAccess from "@/pages/RestrictedAccess";
import RestrictedLogin from "@/pages/RestrictedLogin";
import RestrictedShop from "@/pages/RestrictedShop";
import RestrictedProductDetail from "@/pages/RestrictedProductDetail";
import { RecentOrdersFloating } from "@/components/RecentOrdersFloating";

function App() {
    return (
        <div className="App">
            <AppProvider>
                <BrowserRouter>
                    <AgeGate />
                    <Header />
                    <main className="min-h-[60vh]">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route path="/product/:slug" element={<ProductDetail />} />
                            <Route path="/cart" element={<Cart />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/checkout/success" element={<Success />} />
                            <Route path="/success" element={<Success />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/research-guidelines" element={<ResearchGuidelines />} />
                            <Route path="/research" element={<ResearchGuidelines />} />
                            <Route path="/track" element={<TrackOrder />} />
                            <Route path="/support" element={<Support />} />
                            <Route path="/how-to-pay-with-crypto" element={<HowToPayWithCrypto />} />
                            <Route path="/crypto-guide" element={<HowToPayWithCrypto />} />
                            <Route path="/restricted" element={<RestrictedAccess />} />
                            <Route path="/restricted/login" element={<RestrictedLogin />} />
                            <Route path="/restricted/shop" element={<RestrictedShop />} />
                            <Route path="/restricted/product/:slug" element={<RestrictedProductDetail />} />
                        </Routes>
                    </main>
                    <Footer />
                    <RecentOrdersFloating />
                    <Toaster richColors position="top-right" />
                </BrowserRouter>
            </AppProvider>
        </div>
    );
}

export default App;
